import axios, { AxiosInstance } from 'axios';
import { BASE_URL } from './constants';


// Create separate instances for public and protected APIs
export const publicApi: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const protectedApi: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    "Authorization": `Bearer ${localStorage.getItem("accessToken")}`
  },
});

// Add a request counter for loading states
let activeRequests = 0;

export const getActiveRequestCount = () => activeRequests;

export const incrementRequestCount = () => {
  activeRequests++;
};

export const decrementRequestCount = () => {
  if (activeRequests > 0) activeRequests--;
};